import { mockData as documentAlertData } from '@web/lib/demo/data/documentAlert';
import { filterData, getUsers } from '@web/lib/demo/utils';
export var documentAlertsList = function (input) {
    var _a;
    var orgUnitUserIds = input.orgUnitId
        ? getUsers({ orgUnitId: input.orgUnitId }).map(function (user) { return user.id; })
        : null;
    var filteredData = filterData(documentAlertData, [
        {
            key: 'createdAt',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'createdAt',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: (_a = input.triggeredBy) !== null && _a !== void 0 ? _a : 0,
            operator: 'eq',
            isSkip: !input.triggeredBy
        },
        {
            key: 'userId',
            value: orgUnitUserIds !== null && orgUnitUserIds !== void 0 ? orgUnitUserIds : [],
            operator: 'in',
            isSkip: !orgUnitUserIds
        }
    ]);
    var documentEvents = filteredData.map(function (item) {
        var _a, _b, _c, _d;
        var user = getUsers({}).find(function (userItem) { return userItem.id === item.userId; });
        return {
            id: item.id,
            date: item.createdAt,
            event: item.action,
            document: {
                id: item.documentId,
                title: item.document.title,
                type: item.document.type
            },
            triggeredBy: {
                id: item.userId,
                name: (user === null || user === void 0 ? void 0 : user.name) || '',
                avatar: (user === null || user === void 0 ? void 0 : user.avatar) || '',
                email: (user === null || user === void 0 ? void 0 : user.email) || '',
                orgUnitTitle: (_d = (_c = (_b = (_a = user === null || user === void 0 ? void 0 : user.userOrgUnits) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.orgUnit) === null || _c === void 0 ? void 0 : _c.title) !== null && _d !== void 0 ? _d : null
            }
        };
    });
    return {
        total: documentEvents.length,
        data: documentEvents
    };
};
